import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c77485c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OAtributosAlocacaoUsuario" }
const _hoisted_2 = { class: "OAtributosAlocacaoUsuario__MensagemBotao" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import Avatar from "primevue/avatar"
  import Button from "primevue/button"
  import { useI18n } from "vue-i18n"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OAtributosAlocacaoUsuario',
  setup(__props) {

  const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Avatar), {
      class: "OAtributosAlocacaoUsuario__Avatar",
      icon: "pi pi-calendar",
      shape: "circle"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_unref(t)('esteUsuarioNaoPossuiUm')) + " ", 1),
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_unref(t)('profissionalAssociado')) + " ", 1),
      _createVNode(_unref(Button), {
        class: "OAtributosAlocacaoUsuario__BotaoAdicionarAtributos",
        label: _unref(t)('criarProfissional')
      }, null, 8, ["label"])
    ])
  ]))
}
}

})